"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var navFontSize = exports.navFontSize = {
  type: "select",
  options: [{ label: "10", value: "10px" }, { label: "11", value: "11px" }, { label: "12", value: "12px" }, { label: "13", value: "13px" }, { label: "14", value: "14px" }, { label: "15", value: "15px" }, { label: "16", value: "16px" }, { label: "17", value: "17px" }, { label: "18", value: "18px" }, { label: "19", value: "19px" }, { label: "20", value: "20px" }, { label: "21", value: "21px" }, { label: "22", value: "22px" }, { label: "23", value: "23px" }, { label: "24", value: "24px" }, { label: "25", value: "25px" }, { label: "26", value: "26px" }, { label: "27", value: "27px" }, { label: "28", value: "28px" }, { label: "29", value: "29px" }, { label: "30", value: "30px" }, { label: "31", value: "31px" }, { label: "32", value: "32px" }]
};

var linkTextTransform = exports.linkTextTransform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "lowercase", value: "lowercase" }]
};
var radius = exports.radius = {
  type: "select",
  options: [{ label: "none", value: "0" }, { label: "5", value: "5px" }, { label: "10", value: "10px" }, { label: "15", value: "15px" }, { label: "20", value: "20px" }, { label: "30", value: "30px" }]
};
var linkFontWeight = exports.linkFontWeight = {
  type: "select",
  options: [{ label: "Light", value: "300" }, { label: "Normal", value: "400" }, { label: "Medium", value: "500" }, { label: "Bold", value: "600" }]
};